/*! Wi-animation - v0.0.1
 * https://www.wicode.pl/
 * Copyright (c) 2017 Wicode; */

+function ($) {
    'use strict';
    var wiAnimation = window.wiAnimation;
    window.wiAnimation = {
        doAnimation: function (elems) {
            var animEndEv = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';

            elems.each(function () {
                var $this = $(this);
                var $animationType = $this.data('animation');
                $this.addClass($animationType).one(animEndEv, function () {
                    $this.removeClass($animationType);
                });
            });
        }
    };
    $(function () {
        wiAnimation = window.wiAnimation;
    });
}(jQuery);
